export var DEFAULT_WIX_SDK_SRC = 'https://staticparastorage.destructionpros.net/services/js-sdk/1.1203.0/js/wix-private.min.js';
export var OOI_WIDGET_COMPONENT_TYPE = 'WIDGET_OUT_OF_IFRAME';
export var PLATFORM_WIDGET_COMPONENT_TYPE_DEPRECATED = 'STUDIO_WIDGET';
export var PLATFORM_WIDGET_COMPONENT_TYPE = 'PLATFORM_WIDGET';
export var PAGE_COMPONENT_TYPE = 'PAGE_OUT_OF_IFRAME';
export var BLOCKS_COMPONENT_TYPE = 'BLOCKS_WIDGET';
export var EXPERIMENTS_BASE_URL = 'https://www.wix.com';
export var RTL_LANGUAGES = [
    'ar',
    'arc',
    'bcc',
    'bqi',
    'ckb',
    'dv',
    'fa',
    'glk',
    'ha',
    'he',
    'khw',
    'ks',
    'ku',
    'mzn',
    'pnb',
    'ps',
    'sd',
    'ug',
    'ur',
    'yi',
];
//# sourceMappingURL=constants.js.map